export default "__VITE_ASSET__D82QOeFt__"